// Content-Disposition에서 파일명 추출. downloadBlobResponse(zip·엑셀 다운로드)가 사용한다.
// filename*=UTF-8''(RFC 5987)과 filename="..." 형식 모두 지원.
// 한글은 percent-encoding으로 오므로 디코딩하되, 잘못된 인코딩이면 원본으로 폴백해 다운로드는 성공시킨다.
const parseFilenameFromContentDisposition = (
  contentDisposition: string | null,
  defaultFilename = "이행사진.zip",
): string => {
  if (!contentDisposition) {
    return defaultFilename;
  }
  // filename* (RFC 5987) 우선, 없으면 filename= 사용
  const rfc5987Match = contentDisposition.match(/filename\*\s*=\s*([^;]+)/i);
  const asciiMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i);
  let rawName = "";
  if (rfc5987Match && rfc5987Match[1]) {
    // charset'lang' 프리픽스(예: UTF-8'') 제거
    rawName = rfc5987Match[1].trim().replace(/^[^']*'[^']*'/, "");
  } else if (asciiMatch && asciiMatch[1]) {
    rawName = asciiMatch[1].trim();
  }
  if (!rawName) {
    return defaultFilename;
  }
  let decoded = rawName;
  try {
    decoded = decodeURIComponent(rawName);
  } catch {
    decoded = rawName;
  }
  decoded = decoded.replace(/[/\\]/g, "_").trim(); // 경로 구분자 제거(새니타이즈)
  return decoded || defaultFilename;
};

export default parseFilenameFromContentDisposition;
